import { useCallback } from 'react';
export default (function () { return ({
    addBackButtonListener: useCallback(function (callback) {
        window.history.pushState({}, '');
        window.onpopstate = function (event) {
            event.preventDefault();
            callback();
        };
    }, []),
    removeBackButtonListener: useCallback(function () {
        window.onpopstate = null;
    }, []),
}); });
//# sourceMappingURL=useBrowserBackButton.js.map